/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import bullet from "../../../../images/bullet_primary.svg"
import * as s from './css/vantaggi.module.css'

const testi = [
  'Merchandising esclusivo',
  'Prodotti a tiratura limitata, personalizzati o in prevendita',
  'Libri in anteprima e autografati',
  'Meet & Greet',
  'Pass esclusivi per gli eventi',
  'Promozioni e sconti su alcuni dei brand più conosciuti'
]

const Vantaggi = ({ project }) => {

  return (
    <>
      <div className={`full-container ${s.container}`} style={{ backgroundColor: '#f6f6f6', marginTop: '80px' }}>
        <div className="flex-row container-grid">
          <div className={`flex flex-col col-span-4 desktop:col-span-6`}>
            <div className="flex flex-col flex-grow">
              <div className="font-md text-2 leading-11 desktop:text-24 desktop:leading-16 text-black">
                Scopri Tinaba Hit
              </div>

              <div className="mt-p25 font-rg desktop:mt-p40 text-6 leading-6_1 text-black">
                Apri il conto con Tinaba e acquista la Carta Hit di {project.__influencerName} dal design unico! Se attivi la membership Tinaba Hit con il codice {project.promocode} potrai accedere al suo Store e a tantissimi vantaggi!
              </div>
            </div>

            <div className="flex flex-row" style={{marginTop:'55px'}}>
              <div className="flex flex-col">
                <div className="font-rg text-6 text-primary leading-6_1 text-black">
                  Per attivare la membership usa il codice: 
                </div>

                <div className="font-md text-4 text-primary leading-10 text-black text-center" style={{padding:'14px', marginTop:'11px', borderRadius:'8px', border:'1px solid red'}}>
                  {project.promocode}
                </div>
              </div>
            </div>

          </div>
          <div className={`mt-p40 desktop:mt-0 col-span-4 desktop:row-span-2 desktop:col-start-8 desktop:col-span-5`}>
            {testi.map(d => (
              <div className="flex flex-row mb-p25 items-start">
                <img src={bullet} style={{ marginTop: '6px' }} alt="bullet" />
                <span className="leading-6_1 font-rg text-6 text-black" style={{ marginLeft: '18px' }}>{d}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Vantaggi
